/**
 * One changed field, before and after, stacked so it reads on a phone. With
 * `onToggle` it is a row to tick (the catalogue update); without, it only
 * shows (a repair proposal, which is applied as a whole).
 */
interface Props {
  label: string;
  before: string;
  after: string;
  note?: string;
  checked?: boolean;
  onToggle?: () => void;
}

export function ChangeRow({ label, before, after, note, checked, onToggle }: Props) {
  const body = (
    <>
      <span className="change-label small">{label}</span>
      <span className="change-pair">
        <span className="change-before">
          <span className="tiny muted change-tag">−</span>
          <pre className="ltr mono tiny" dir="ltr">
            {before}
          </pre>
        </span>
        <span className="change-after">
          <span className="tiny change-tag">+</span>
          <pre className="ltr mono tiny" dir="ltr">
            {after}
          </pre>
        </span>
      </span>
      {note && <span className="muted tiny">{note}</span>}
    </>
  );

  return (
    <li className="change-row">
      {onToggle ? (
        <label className="change-check">
          <input type="checkbox" checked={Boolean(checked)} onChange={onToggle} />
          <span className="change-body">{body}</span>
        </label>
      ) : (
        <div className="change-body">{body}</div>
      )}
    </li>
  );
}
